import httpClient from './Http'

export default {

	sendMessageFromCurrentUserToProUser(to, body){
        const conversationEndpoint = `/pro/${to.id}/conversation`;
        const message = {
          to : to,
          body : body,
        };

        return httpClient.post(conversationEndpoint, message);
	},
}



// WEBPACK FOOTER //
// ./src/main/frontend/vue/js/api/MessagingService.js